module.exports = __webpack_public_path__ + "2-4c0a0258.png";